// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Geofence, PostGeofenceRequest } from '../../types/Geofences';
import { postGeofence } from '../../services/GeofencesService';

type ApiError = {
  statusCode: number;
  message: string;
  error: string;
};

type Result = UseMutationResult<Geofence, AxiosError<ApiError>, PostGeofenceRequest>;

function usePostGeofence(
  successCb: () => void,
  failureCb: (error: string) => void,
): Result {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postGeofence,
    onSuccess: (_, variables) => {
      successCb();

      queryClient.invalidateQueries({
        queryKey: ['geofences', variables.fleetId],
      });
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message ?? error.message ?? 'Something went wrong';
      failureCb(errorMessage);
    },
  });
}

export default usePostGeofence;
